import React from "react";
import AudioPlayer from "../AudioPlayer";
import AudioRecorder from "../AudioRecorder";
import AudioFeedback from "../AIAudioFeedback";
import TeacherFeedbackEditor from "../TeacherFeedbackEditor";
import formatFeedback from "./formatFeedback";
import { avatarImages } from "../../../profilepage/AvatarConfig";

const AudioRecorderWrapper = ({
  index,
  material,
  reRecordingIndex,
  studentResponses,
  handleAudioSave,
  handleRetry,
  handleMaterialChange,
  isTeacher,
  isViewingAsStudent,
  aiFeedback,
  editingFeedback,
  setEditingFeedback,
  handleSaveFeedback,
  handleAIFeedbackRequest,
  moduleData,
}) => {
  if (reRecordingIndex === index) {
    return (
      <AudioRecorder
        onSave={(audioBlob) => handleAudioSave(audioBlob, material.questionId)}
        onRecordingComplete={() => {}}
        questionId={material.questionId}
        question={material.question}
        onChange={(changes) => handleMaterialChange(index, changes)}
        isStudentView={true}
        border={material.border}
        score={material.score || 0}
        tip={material.tip}
      />
    );
  }

  if (studentResponses[material.questionId]?.answer) {
    return (
      <>
        <AudioPlayer
          audioURL={studentResponses[material.questionId].answer}
          onRetry={() => handleRetry(index)}
          question={material.question}
          onChange={(changes) => handleMaterialChange(index, changes)}
          isStudentView={true}
          tip={material.tip}
          border={material.border}
        />
        {isTeacher && isViewingAsStudent ? (
          <TeacherFeedbackEditor
            feedback={studentResponses[material.questionId]?.grade?.feedback}
            onSave={handleSaveFeedback}
            questionId={material.questionId}
            isEditing={editingFeedback === material.questionId}
            onEditClick={setEditingFeedback}
            onAIFeedbackRequest={handleAIFeedbackRequest}
            aiFeedback={aiFeedback[material.questionId]}
            isTeacher={isTeacher}
            studentResponses={studentResponses}
            questionType="AudioRecording"
          />
        ) : studentResponses[material.questionId]?.grade?.feedback ? (
          <div className="teacher-feedback student-feedback">
            <div className="feedback-header">
              <h4>Teacher's Feedback:</h4>
            </div>
            <div className="feedback-content-wrapper">
              {studentResponses?.[material.questionId]?.grade?.graderAvatar && (
                <img
                  src={
                    avatarImages[
                      studentResponses[material.questionId].grade.graderAvatar
                    ]
                  }
                  alt="Teacher Avatar"
                  className="feedback-avatar"
                />
              )}
              <div className="feedback-content">
                {studentResponses?.[material.questionId]?.grade?.gradedAt && (
                  <div className="feedback-meta">
                    <small>
                      <strong>
                        {studentResponses[material.questionId].grade.graderName}
                      </strong>{" "}
                      on{" "}
                      {(() => {
                        const grade =
                          studentResponses[material.questionId].grade;
                        let timestamp;
                        if (grade.gradedAt.seconds) {
                          timestamp = grade.gradedAt.seconds * 1000;
                        } else if (grade.gradedAt instanceof Date) {
                          timestamp = grade.gradedAt.getTime();
                        } else if (grade.gradedAt._seconds) {
                          timestamp = grade.gradedAt._seconds * 1000;
                        } else {
                          timestamp = grade.gradedAt;
                        }

                        const date = new Date(timestamp);
                        if (isNaN(date.getTime())) {
                          console.error("Invalid date:", grade.gradedAt);
                          return "";
                        }

                        return date.toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        });
                      })()}
                    </small>
                  </div>
                )}
                <p
                  dangerouslySetInnerHTML={{
                    __html: formatFeedback.formatForDisplay(
                      studentResponses[material.questionId].grade.feedback
                    ),
                  }}
                />
              </div>
            </div>
          </div>
        ) : (
          !moduleData?.settings?.isQuizMode && (
            <AudioFeedback
              audioURL={studentResponses[material.questionId].answer}
            />
          )
        )}
      </>
    );
  }

  return (
    <AudioRecorder
      onSave={(audioBlob) => handleAudioSave(audioBlob, material.questionId)}
      onRecordingComplete={() => {}}
      questionId={material.questionId}
      question={material.question}
      onChange={(changes) => handleMaterialChange(index, changes)}
      isStudentView={true}
      border={material.border}
      score={material.score || 0}
      tip={material.tip}
    />
  );
};

export default AudioRecorderWrapper;
